// diamondPacks.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_DIAMOND_PACKS,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Diamond packs.
 * @module reducer/diamondPacks
 */
const diamondPacks = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_DIAMOND_PACKS:
      return _ADD_DIAMOND_PACKS(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Add diamond packs
 * @kind reducer/actionType
 * @name ADD_DIAMOND_PACKS
 * @param {object} {diamondPacks} - diamond packs using sku id as keys.
 * @return {Immutable.Map} New state
 */
const _ADD_DIAMOND_PACKS =
  ({ diamondPacks }) =>
  state => {
    return state.mergeDeep(diamondPacks);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default diamondPacks;
